
export const COMPANY_STATUS = {
  PENDING: 'PENDING',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
}

export const MAP_RESULT_TO_STATUS = {
  APPROVED: COMPANY_STATUS.ENABLED,
  ENABLED: COMPANY_STATUS.ENABLED,
  DELETED: 'DELETED', // rejected
  DISABLED: COMPANY_STATUS.DISABLED,
}